import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    Checkbox,
    DialogActions,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { LabelCompo } from "../../components/Comman/Label";

import { ButtonCompo } from "../../components/Comman/Button";
import { blackColor, checkboxColor } from "../../config/ColorObj";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import FileUploadIcon from "@mui/icons-material/FileUpload";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ValidateDataTablePopUp = ({
    handleCloses,
    open,
    validateDataList,
    onImportValidatedData,
    columnTag,
    validationTableTitle,
}) => {
    const [searchValue, setSearchValue] = React.useState("");
    const handleClose = () => {
        handleCloses();
    };

    const onSearchBox = (searchValue) => {
        setSearchValue(searchValue);
    };

    const getFilteredTableData = (searchData) => {
        if (!searchValue?.trim()) return searchData;

        const searchTerm = searchValue.trim().toLowerCase();

        return searchData.filter((row) => {
            const values = Object.values(row).map((value) => {
                if (value && typeof value === "object" && !Array.isArray(value)) {
                    return Object.values(value);
                }
                return value;
            });

            return values.some((value) =>
                value?.toString().toLowerCase().includes(searchTerm)
            );
        });
    };

    const tableWrapperStyle = {
        maxWidth: "100%",
        overflowX: "auto",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e0e0e0",
    };

    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        fontSize: "14px",
        color: "#333",
    };

    const thStyle = {
        padding: "14px 12px",
        textAlign: "center",
        fontWeight: "600",
        color: "black",
        backgroundColor: "#FAFAFA",
        borderBottom: "1px black solid",
        whiteSpace: "nowrap",
        borderRight: "1px solid #ccc",
    };

    const td = {
        padding: "12px 10px",
        textAlign: "left",
        whiteSpace: "nowrap",
        borderBottom: "3px blue ",
        borderRight: "1px solid #ccc",
        fontWeight: "550",
        color: "black",
        backgroundColor: "#F88870",
    };

    //   const tdCenter = {
    //     ...td,
    //     textAlign: "center",
    //   };

    const tdLeft = {
        width: "15%",
        textAlign: "left",
        borderRight: "2px solid #eee",
        paddingLeft: "10px",
    };

    const tdCenter = {
        width: "15%",
        textAlign: "center",
        borderRight: "2px solid #eee",
        paddingLeft: "10px",
    };

    return (
        <>
            <Paper sx={{ p: 3, pt: 2, borderRadius: 2 }} elevation={0}>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth={columnTag == 7 || columnTag == 8 ? "xl" : "lg"}
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                        backgroundColor="#F0F0F0"
                        fontFamily="'Montserrat', sans-serif"
                        fontSize="23px"
                        color="black"
                    >
                        {validationTableTitle}
                    </BootstrapDialogTitle>

                    <>
                        <DialogContent dividers>
                            <div style={{ marginLeft: "-9px" }}>
                                <LandingScreenHeader
                                    screenTitle={""}
                                    showSearchBox={true}
                                    showTable={true}
                                    showFilter={false}
                                    showPdfDownload={false}
                                    showExcelDownload={false}
                                    onSearch={onSearchBox}
                                />
                            </div>

                            <div style={{ maxWidth: "100%", overflowX: "auto" }}>
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        fontFamily:
                                            "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                        fontSize: "14px",
                                        color: "#333",
                                        maxWidth: "100%",
                                        overflowX: "auto",
                                        borderRadius: "8px",
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                                        border: "2px solid #e0e0e0",
                                    }}
                                >
                                    <thead>
                                        {columnTag === 9 ? (
                                            <tr
                                                style={{
                                                    backgroundColor: "#f5f5f5",
                                                    borderBottom: "2px solid #ddd",
                                                }}
                                            >
                                                <th style={thStyle}>Sr. No</th>
                                                <th style={thStyle}>Header Name</th>
                                                <th style={thStyle}>Year Name</th>
                                                <th style={thStyle}>Active Status</th>
                                                <th style={thStyle}>Detail Name</th>
                                                <th style={thStyle}>From Date</th>
                                                <th style={thStyle}>To Date</th>
                                                <th style={thStyle}>Detail Ru Factor</th>
                                                <th style={thStyle}>Detail Sort Order</th>
                                                <th style={thStyle}>Error Message</th>
                                            </tr>
                                        ) : columnTag === 10 ? (
                                            <tr
                                                style={{
                                                    backgroundColor: "#f5f5f5",
                                                    borderBottom: "2px solid #ddd",
                                                }}
                                            >
                                                <th style={thStyle}>Sr. No</th>
                                                <th style={thStyle}>Retail Unit Target Name</th>
                                                <th style={thStyle}>Sales Team Name</th>
                                                <th style={thStyle}>User Name</th>
                                                <th style={thStyle}>Active Status</th>
                                                <th style={thStyle}>Error Message</th>
                                            </tr>
                                        ) : columnTag === 8 ? (
                                            <tr
                                                style={{
                                                    backgroundColor: "#f5f5f5",
                                                    borderBottom: "2px solid #ddd",
                                                }}
                                            >
                                                <th style={thStyle}>Sr. No</th>
                                                <th style={thStyle}>Header Name</th>
                                                <th style={thStyle}>Year Name</th>
                                                <th style={thStyle}>Publish Date</th>
                                                <th style={thStyle}>Detail Product Name</th>
                                                <th style={thStyle}>Detail Product Code</th>
                                                <th style={thStyle}>Detail Uom Name</th>
                                                <th style={thStyle}>Detail Ru Factor</th>
                                                <th style={thStyle}>Detail Primary Qty</th>
                                                <th style={thStyle}>Error Message</th>
                                            </tr>
                                        ) : columnTag === 7 ? (
                                            <tr
                                                style={{
                                                    backgroundColor: "#f5f5f5",
                                                    borderBottom: "2px solid #ddd",
                                                }}
                                            >
                                                <th style={thStyle}>Sr. No</th>
                                                <th style={thStyle}>Stock Stake Holder Types</th>
                                                <th style={thStyle}>Region</th>
                                                <th style={thStyle}>Zones</th>
                                                <th style={thStyle}>Areas</th>
                                                <th style={thStyle}>Notice Headline</th>
                                                <th style={thStyle}>Description</th>
                                                <th style={thStyle}>Type</th>
                                                <th style={thStyle}>Flash</th>
                                                <th style={thStyle}>From Date</th>
                                                <th style={thStyle}>To Date</th>
                                                <th style={thStyle}>Error Message</th>
                                            </tr>
                                        ) : (
                                            <tr
                                                style={{
                                                    backgroundColor: "#f5f5f5",
                                                    borderBottom: "2px solid #ddd",
                                                }}
                                            >
                                                <th style={thStyle}>Sr. No</th>
                                                <th style={thStyle}>Name</th>
                                                {columnTag === 2 && <th style={thStyle}>Code</th>}
                                                <th style={thStyle}>
                                                    {columnTag === 1
                                                        ? "Country Name"
                                                        : columnTag === 2
                                                            ? "Region Name"
                                                            : columnTag === 3
                                                                ? "State Name"
                                                                : columnTag === 4
                                                                    ? "Zone Name"
                                                                    : columnTag === 5
                                                                        ? "District Name"
                                                                        : columnTag === 6
                                                                            ? "Taluka Name"
                                                                            : ""}
                                                </th>
                                                <th style={thStyle}>Short Name</th>
                                                <th style={thStyle}>Sort Order</th>
                                                <th style={thStyle}>Error Message</th>
                                            </tr>
                                        )}
                                    </thead>

                                    <tbody>
                                        {getFilteredTableData(validateDataList).map(
                                            (validateDataListObj, indexRow) => {
                                                let countryName = "";
                                                let regionName = "";
                                                let stateName = "";
                                                let zoneName = "";
                                                let districtName = "";
                                                let talukaName = "";
                                                let sortOrderNo = "";

                                                if (columnTag == 1) {
                                                    countryName = validateDataListObj.country?.name ?? "";

                                                    sortOrderNo =
                                                        validateDataListObj.flag == 1
                                                            ? validateDataListObj.sortOrde ?? ""
                                                            : validateDataListObj.sortOrder ?? "";
                                                } else if (columnTag == 2) {
                                                    regionName =
                                                        validateDataListObj.region !== null &&
                                                            validateDataListObj.region.name !== null
                                                            ? validateDataListObj.region.name
                                                            : "";

                                                    sortOrderNo =
                                                        validateDataListObj.flag == 1
                                                            ? validateDataListObj.sortOrderN !== null
                                                                ? validateDataListObj.sortOrderN
                                                                : ""
                                                            : validateDataListObj.sortOrderNo !== null
                                                                ? validateDataListObj.sortOrderNo
                                                                : "";
                                                } else if (columnTag == 3) {
                                                    stateName =
                                                        validateDataListObj.state !== null &&
                                                            validateDataListObj.state.name !== null
                                                            ? validateDataListObj.state.name
                                                            : "";

                                                    sortOrderNo =
                                                        validateDataListObj.flag == 1
                                                            ? validateDataListObj.sortOrde !== null
                                                                ? validateDataListObj.sortOrde
                                                                : ""
                                                            : validateDataListObj.sortOrder !== null
                                                                ? validateDataListObj.sortOrder
                                                                : "";
                                                } else if (columnTag == 4) {
                                                    zoneName =
                                                        validateDataListObj.zone !== null &&
                                                            validateDataListObj.zone.name !== null
                                                            ? validateDataListObj.zone.name
                                                            : "";

                                                    sortOrderNo =
                                                        validateDataListObj.flag == 1
                                                            ? validateDataListObj.sortOrde !== null
                                                                ? validateDataListObj.sortOrde
                                                                : ""
                                                            : validateDataListObj.sortOrder !== null
                                                                ? validateDataListObj.sortOrder
                                                                : "";
                                                } else if (columnTag == 5) {
                                                    districtName =
                                                        validateDataListObj.district !== null &&
                                                            validateDataListObj.district.name !== null
                                                            ? validateDataListObj.district.name
                                                            : "";

                                                    sortOrderNo =
                                                        validateDataListObj.flag == 1
                                                            ? validateDataListObj.sortOrde !== null
                                                                ? validateDataListObj.sortOrde
                                                                : ""
                                                            : validateDataListObj.sortOrder !== null
                                                                ? validateDataListObj.sortOrder
                                                                : "";
                                                } else if (columnTag == 6) {
                                                    talukaName =
                                                        validateDataListObj.taluka !== null &&
                                                            validateDataListObj.taluka.name !== null
                                                            ? validateDataListObj.taluka.name
                                                            : "";

                                                    sortOrderNo =
                                                        validateDataListObj.flag == 1
                                                            ? validateDataListObj.sortOrde !== null
                                                                ? validateDataListObj.sortOrde
                                                                : ""
                                                            : validateDataListObj.sortOrder !== null
                                                                ? validateDataListObj.sortOrder
                                                                : "";
                                                }

                                                return (
                                                    <>
                                                        {columnTag == 9 ? (
                                                            <tr
                                                                style={
                                                                    validateDataListObj.flag == 1
                                                                        ? {
                                                                            backgroundColor: "#ed8e98",
                                                                            borderBottom: "2px solid #eee",
                                                                        }
                                                                        : {}
                                                                }
                                                            >
                                                                <td style={tdCenter}>{indexRow + 1}</td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.headerName || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.year !== null &&
                                                                        validateDataListObj.year.yearName}
                                                                </td>

                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 1
                                                                        ? validateDataListObj.active || ""
                                                                        : validateDataListObj.isActive == 1
                                                                            ? "Active"
                                                                            : "InActive"}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.detailName}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.fromDate}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.toDate}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.ruQty}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.sortOrder}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 0
                                                                        ? "-"
                                                                        : validateDataListObj.errorMessage || ""}
                                                                </td>
                                                            </tr>
                                                        ) : columnTag == 10 ? (
                                                            <tr
                                                                style={
                                                                    validateDataListObj.flag == 1
                                                                        ? {
                                                                            backgroundColor: "#ed8e98",
                                                                            borderBottom: "2px solid #eee",
                                                                        }
                                                                        : {}
                                                                }
                                                            >
                                                                <td style={tdCenter}>{indexRow + 1}</td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj
                                                                        .retailUnitWiseTargetHeader?.name || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.flag == 0
                                                                        ? validateDataListObj.salesTeam !== null &&
                                                                            validateDataListObj.salesTeam.name !==
                                                                            null &&
                                                                            validateDataListObj.salesTeam
                                                                                .stockStakeHolderType !== null &&
                                                                            validateDataListObj.salesTeam
                                                                                .stockStakeHolderType.prefix !== null
                                                                            ? validateDataListObj.salesTeam.name +
                                                                            " (" +
                                                                            validateDataListObj.salesTeam
                                                                                .stockStakeHolderType.prefix +
                                                                            ")"
                                                                            : ""
                                                                        : validateDataListObj.salesTeam !== null &&
                                                                            validateDataListObj.salesTeam.name !==
                                                                            null
                                                                            ? validateDataListObj.salesTeam.name
                                                                            : ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.flag == 1
                                                                        ? validateDataListObj.userName || ""
                                                                        : validateDataListObj.salesTeam?.userName ||
                                                                        ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 1
                                                                        ? validateDataListObj.active || ""
                                                                        : validateDataListObj.isActive == 1
                                                                            ? "Active"
                                                                            : "InActive"}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 0
                                                                        ? "-"
                                                                        : validateDataListObj.errorMessage || ""}
                                                                </td>
                                                            </tr>
                                                        ) : columnTag == 8 ? (
                                                            <tr
                                                                style={
                                                                    validateDataListObj.flag == 1
                                                                        ? {
                                                                            backgroundColor: "#ed8e98",
                                                                            borderBottom: "2px solid #eee",
                                                                        }
                                                                        : {}
                                                                }
                                                            >
                                                                <td style={tdCenter}>{indexRow + 1}</td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.name || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.year?.yearName || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 1
                                                                        ? validateDataListObj.pdate || ""
                                                                        : validateDataListObj.publishDate || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.product?.name || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.product?.code || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.uom?.name || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 1
                                                                        ? validateDataListObj.rqty || ""
                                                                        : validateDataListObj.ruQty || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 1
                                                                        ? validateDataListObj.pqty || ""
                                                                        : validateDataListObj.primaryQty || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 0
                                                                        ? "-"
                                                                        : validateDataListObj.errorMessage || ""}
                                                                </td>
                                                            </tr>
                                                        ) : columnTag == 7 ? (
                                                            <tr
                                                                style={
                                                                    validateDataListObj.flag == 1
                                                                        ? {
                                                                            backgroundColor: "#ed8e98",
                                                                            borderBottom: "2px solid #eee",
                                                                        }
                                                                        : {}
                                                                }
                                                            >
                                                                <td style={tdCenter}>{indexRow + 1}</td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.stockStakeHolderTypeNames ||
                                                                        ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.regionNames || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.zoneNames || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.areaNames || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.noticeHeadline || ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.description || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.type != null
                                                                        ? validateDataListObj.type == 0
                                                                            ? "Notice"
                                                                            : "Message"
                                                                        : ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flash != null
                                                                        ? validateDataListObj.flash == 1
                                                                            ? "Yes"
                                                                            : "No"
                                                                        : ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.fromdate || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.todate || ""}
                                                                </td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 0
                                                                        ? "-"
                                                                        : validateDataListObj.errorMessage || ""}
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr
                                                                style={
                                                                    validateDataListObj.flag == 1
                                                                        ? {
                                                                            backgroundColor: "#ed8e98",
                                                                            borderBottom: "2px solid #eee",
                                                                        }
                                                                        : {}
                                                                }
                                                            >
                                                                <td style={tdCenter}>{indexRow + 1}</td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.name || ""}
                                                                </td>
                                                                {columnTag == 2 && (
                                                                    <td style={tdLeft}>
                                                                        {validateDataListObj.code || ""}
                                                                    </td>
                                                                )}
                                                                <td style={tdLeft}>
                                                                    {columnTag == 1
                                                                        ? countryName
                                                                        : columnTag == 2
                                                                            ? regionName
                                                                            : columnTag == 3
                                                                                ? stateName
                                                                                : columnTag == 4
                                                                                    ? zoneName
                                                                                    : columnTag == 5
                                                                                        ? districtName
                                                                                        : columnTag == 6
                                                                                            ? talukaName
                                                                                            : ""}
                                                                </td>
                                                                <td style={tdLeft}>
                                                                    {validateDataListObj.shortName || ""}
                                                                </td>
                                                                <td style={tdCenter}>{sortOrderNo}</td>
                                                                <td style={tdCenter}>
                                                                    {validateDataListObj.flag == 0
                                                                        ? "-"
                                                                        : validateDataListObj.errorMessage || ""}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </DialogContent>
                    </>
                    <DialogActions sx={{ justifyContent: "flex-end", padding: 5 }}>
                        <Button
                            size="medium"
                            type="submit"
                            variant="contained"
                            name="Import Validated Only"
                            color="primary"
                            fon
                            startIcon={<FileUploadIcon />}
                            sx={{
                                color: "#fff",
                                mr: 2,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                transition: "all 0.2s",
                                minWidth: "120px",
                                height: "35px",
                                "&:hover": {
                                    backgroundColor: "#1976d2",
                                    transform: "translateY(-2px)",
                                },
                            }}
                            onClick={onImportValidatedData}
                        >
                            Import Validated Only
                        </Button>
                    </DialogActions>
                </BootstrapDialog>
            </Paper>
        </>
    );
};
const mapStateToProps = (state) => ({
    beatList: state.beat,
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidateDataTablePopUp);
